import { supabase } from '../lib/supabase'
import { parseEdgeFunctionError } from './comercialCotacoes'

export interface ParceiroOption {
  id: string
  nome: string
  requiresCpf: boolean
  requiresOs: boolean
}

export const PARCEIROS_OPTIONS: ParceiroOption[] = [
  { id: '21', nome: 'Allya', requiresCpf: false, requiresOs: false },
  { id: '16', nome: 'Sulamérica', requiresCpf: false, requiresOs: false },
  { id: '22', nome: 'Dasa', requiresCpf: false, requiresOs: false },
  { id: '18', nome: 'Infinity', requiresCpf: false, requiresOs: true },
  { id: '26', nome: 'Namu', requiresCpf: true, requiresOs: false },
  { id: '4', nome: 'SOS Dental', requiresCpf: true, requiresOs: false },
  { id: '24', nome: 'Omni', requiresCpf: true, requiresOs: false },
]

export interface ConsultaParceiroPayload {
  parceiro: string
  sistemaOperacional?: string
  codigoAssistencia?: string
  nomeSegurado?: string
  cpfSegurado?: string
}

export interface ConsultaParceiroResponse {
  success: boolean
  url?: string
  parceiro?: string
  sistemaOperacional?: string
  error?: string
}

function getBasicAuthHeader(): string {
  const username = import.meta.env.VITE_MIDDLEWARE_STATIONS_USERNAME ?? ''
  const password = import.meta.env.VITE_MIDDLEWARE_STATIONS_PASSWORD ?? ''

  if (!username || !password) {
    throw new Error(
      'Credenciais do middleware não configuradas. Defina VITE_MIDDLEWARE_STATIONS_USERNAME e VITE_MIDDLEWARE_STATIONS_PASSWORD no .env'
    )
  }

  return `Basic ${btoa(`${username}:${password}`)}`
}

export function validateConsultaPayload(payload: ConsultaParceiroPayload): string | null {
  if (!payload.parceiro) {
    return 'Selecione um parceiro.'
  }

  const option = PARCEIROS_OPTIONS.find((p) => p.id === payload.parceiro)
  if (!option) {
    return 'Parceiro inválido.'
  }

  if (option.requiresCpf && !payload.cpfSegurado?.trim()) {
    return `CPF do segurado é obrigatório para o parceiro ${option.nome}.`
  }

  if (option.requiresOs && !payload.sistemaOperacional) {
    return `Sistema operacional é obrigatório para o parceiro ${option.nome}.`
  }

  return null
}

export async function consultarParceiro(
  payload: ConsultaParceiroPayload
): Promise<ConsultaParceiroResponse> {
  const validationError = validateConsultaPayload(payload)
  if (validationError) {
    throw new Error(validationError)
  }

  const body: ConsultaParceiroPayload = {
    parceiro: payload.parceiro,
    sistemaOperacional: payload.sistemaOperacional || 'web',
  }

  if (payload.codigoAssistencia?.trim()) {
    body.codigoAssistencia = payload.codigoAssistencia.trim()
  }
  if (payload.nomeSegurado?.trim()) {
    body.nomeSegurado = payload.nomeSegurado.trim()
  }
  if (payload.cpfSegurado?.trim()) {
    body.cpfSegurado = payload.cpfSegurado.trim()
  }

  const { data, error } = await supabase.functions.invoke('middleware-parceiros', {
    body,
    headers: {
      Authorization: getBasicAuthHeader(),
    },
  })

  if (error) {
    throw new Error(parseEdgeFunctionError(error, data))
  }

  const response = (data ?? {}) as ConsultaParceiroResponse

  if (!response.success) {
    throw new Error(response.error || parseEdgeFunctionError(null, data))
  }

  return response
}
